/* SMAEL — carrinho (pop-up/gaveta): Shipping Protection (interruptor otimista), "Complete your collection" (montado aqui a partir de JSON),
   adicionar rápido por cor, contagem sem a proteção.
   Velocidade: o interruptor muda NA HORA (visual + total do botão) e só depois confirma com UMA requisição que já devolve o HTML novo da gaveta.
   O produto "Shipping Protection" ($2.99) fica escondido na loja toda (ver layout/theme.liquid e filtros de busca/recomendações). */
import { sectionRenderer, morphSection } from '@theme/section-renderer';

(function () {
  var SECTION = 'cart-drawer-section';
  var inflight = false;
  var wanted = null;            // true/false: último estado que o cliente pediu para a proteção
  var upsellData = null;
  var money = null;

  function fmt(cents) {
    try {
      money = money || new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      return money.format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function post(url, body) {
    body.sections = SECTION; body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }

  /* ---- contagem do ícone do carrinho (sem a proteção) ---- */
  function protOn() { var b = document.querySelector('[data-smael-protect]'); return !!(b && b.getAttribute('data-on') === '1'); }
  function hiddenCount() { var e = document.querySelector('[ref="cartItemCount"]'); return e ? parseInt(e.textContent, 10) || 0 : null; }
  function setBubble(n, animate) {
    document.querySelectorAll('cart-icon').forEach(function (ci) { if (typeof ci.renderCartBubble === 'function') ci.renderCartBubble(n, !!animate); });
  }

  /* ---- aplica a resposta (HTML novo da gaveta) ---- */
  function apply(json, animateBubble) {
    var html = json && json.sections && json.sections[SECTION];
    var p = html ? morphSection(SECTION, html, { mode: 'hydration' }) : sectionRenderer.renderSection(SECTION, { cache: false, mode: 'hydration' });
    return Promise.resolve(p).then(function () {
      var n = hiddenCount(); if (n !== null) setBubble(n, animateBubble);
      afterRender();
    });
  }

  /* ---- Shipping Protection ---- */
  function setTotalLocal(box, want) {
    var btn = document.querySelector('#cart-drawer .cart__checkout-button');
    if (!btn) return;
    var total = parseInt(btn.getAttribute('data-total-cents'), 10);
    var price = parseInt(box.getAttribute('data-price-cents'), 10) || 299;
    if (isNaN(total)) return;
    var next = want ? total + price : total - price;
    btn.setAttribute('data-total-cents', String(next));
    var el = btn.querySelector('.smc-cta-total');
    if (el) { el.textContent = fmt(next); el.classList.remove('smc-tick'); void el.offsetWidth; el.classList.add('smc-tick'); }
  }

  function sendProtect() {
    if (inflight || wanted === null) return;
    var box = document.querySelector('[data-smael-protect]'); if (!box) { wanted = null; return; }
    var want = wanted; wanted = null; inflight = true;
    var id = Number(box.getAttribute('data-variant-id'));
    var req = want ? post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }) : post('/cart/change.js', { id: String(id), quantity: 0 });
    req.then(function (j) { if (wanted === null) return apply(j, false); })       // se o cliente já mudou de ideia, não sobrescreve a tela
      .catch(function () {
        var b = document.querySelector('[data-smael-protect]'); var t = b && b.querySelector('[data-smael-protect-toggle]');
        if (b && t) { var wasOn = !want; b.setAttribute('data-on', wasOn ? '1' : '0'); t.checked = wasOn; setTotalLocal(b, wasOn); }
        wanted = null;
      })
      .then(function () { inflight = false; if (wanted !== null) sendProtect(); });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-smael-protect-toggle]')) return;
    var box = t.closest('[data-smael-protect]');
    var want = t.checked;
    box.setAttribute('data-on', want ? '1' : '0');          // visual imediato
    setTotalLocal(box, want);                                // total do botão imediato
    wanted = want;
    sendProtect();
  });

  /* ---- adicionar rápido (cores do "Complete your collection") ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-smael-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true; b.classList.add('is-adding');
    post('/cart/add.js', { items: [{ id: Number(b.getAttribute('data-smael-quick-add')), quantity: 1 }] })
      .then(function (j) { return apply(j, true); })
      .catch(function () { b.disabled = false; b.classList.remove('is-adding'); });
  });

  /* ---- se só a proteção sobrou no carrinho, remove ---- */
  function checkOrphan() {
    if (inflight) return;
    var o = document.querySelector('[data-smael-protect][data-orphan="1"]');
    if (!o) return;
    inflight = true;
    post('/cart/change.js', { id: String(o.getAttribute('data-variant-id')), quantity: 0 })
      .then(function (j) { return apply(j, false); }).catch(function () {}).then(function () { inflight = false; });
  }

  /* ---- "Complete your collection" montado a partir do JSON (fora da seção do carrinho = seção leve) ---- */
  function loadData() {
    if (upsellData) return upsellData;
    var el = document.getElementById('smael-cart-data');
    try { upsellData = el ? JSON.parse(el.textContent) : []; } catch (err) { upsellData = []; }
    return upsellData;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function buildUpsell() {
    var slots = document.querySelectorAll('[data-smael-upsell]');
    if (!slots.length) return;
    var inCart = {};
    document.querySelectorAll('#cart-drawer tr[data-product-id]').forEach(function (r) { inCart[r.getAttribute('data-product-id')] = 1; });
    var items = loadData().filter(function (p) { return !inCart[String(p.id)] && p.variants && p.variants.length; }).slice(0, 4);
    var key = items.map(function (p) { return p.id; }).join(',');
    slots.forEach(function (slot) {
      if (slot.getAttribute('data-built') === key && slot.firstChild) return;
      slot.setAttribute('data-built', key);
      if (!items.length) { slot.innerHTML = ''; return; }
      var title = slot.getAttribute('data-smael-upsell') || 'You may also like';
      slot.innerHTML = '<h3 class="smc-up__h">' + esc(title) + '</h3><ul class="smc-up__row">' + items.map(function (p) {
        var dots = p.variants.slice(0, 6).map(function (v) {
          return '<button type="button" class="smc-dot" data-smael-quick-add="' + v.id + '" aria-label="Add ' + esc(p.title) + ' — ' + esc(v.t) + ' to cart" title="' + esc(v.t) + '">' + (v.img ? '<img src="' + esc(v.img) + '" alt="" width="24" height="24" loading="lazy" decoding="async">' : '') + '</button>';
        }).join('');
        return '<li class="smc-up__card"><a class="smc-up__top" href="' + esc(p.url) + '"><span class="smc-up__img"><img src="' + esc(p.img) + '" alt="" width="52" height="52" loading="lazy" decoding="async"></span><span class="smc-up__info"><span class="smc-up__name">' + esc(p.title) + '</span><span class="smc-up__price">' + esc(p.price) + (p.compare ? ' <s>' + esc(p.compare) + '</s>' : '') + '</span></span></a><div class="smc-up__dots" role="group" aria-label="Quick add by color">' + dots + '</div></li>';
      }).join('') + '</ul><div class="smc-up__nav" role="tablist" aria-label="Watches">' + items.map(function (p, i) { return '<button type="button" class="smc-up__pip" data-smc-pip="' + i + '" aria-label="Show ' + esc(p.title) + '"></button>'; }).join('') + '</div>';
    });
    startRotator();
  }

  /* desktop: um relógio por vez, troca sozinha a cada 2s (pausa com o mouse em cima ou com a gaveta fechada) */
  var rotTimer = null, rotIndex = 0, rotPaused = false;
  var desktopMQ = window.matchMedia('(min-width: 750px)');
  function showCard(slot, i) {
    var cards = slot.querySelectorAll('.smc-up__card'); if (!cards.length) return;
    rotIndex = (i + cards.length) % cards.length;
    cards.forEach(function (c, k) { c.classList.toggle('is-active', k === rotIndex); });
    slot.querySelectorAll('.smc-up__pip').forEach(function (b, k) { b.classList.toggle('is-active', k === rotIndex); });
  }
  function startRotator() {
    clearInterval(rotTimer);
    var slots = document.querySelectorAll('[data-smael-upsell]');
    slots.forEach(function (slot) {
      if (!slot.querySelector('.smc-up__card')) return;
      if (!slot.__smcBound) {
        slot.__smcBound = true;
        slot.addEventListener('mouseenter', function () { rotPaused = true; });
        slot.addEventListener('mouseleave', function () { rotPaused = false; });
        slot.addEventListener('focusin', function () { rotPaused = true; });
        slot.addEventListener('focusout', function () { rotPaused = false; });
        slot.addEventListener('click', function (e) {
          var pip = e.target.closest && e.target.closest('[data-smc-pip]');
          if (pip) showCard(slot, parseInt(pip.getAttribute('data-smc-pip'), 10));
        });
      }
      showCard(slot, Math.min(rotIndex, slot.querySelectorAll('.smc-up__card').length - 1));
    });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rotTimer = setInterval(function () {
      if (rotPaused || reduce || !desktopMQ.matches) return;
      var dlg = document.querySelector('#cart-drawer dialog'); if (!dlg || !dlg.open) return;
      document.querySelectorAll('[data-smael-upsell]').forEach(function (slot) { if (slot.querySelector('.smc-up__card')) showCard(slot, rotIndex + 1); });
    }, 2000);
  }

  function syncToggle() {
    var b = document.querySelector('[data-smael-protect]'); if (!b) return;
    var t = b.querySelector('[data-smael-protect-toggle]');
    if (t && wanted === null && !inflight) t.checked = b.getAttribute('data-on') === '1';
  }
  function afterRender() { buildUpsell(); syncToggle(); checkOrphan(); }

  var timer = null;
  function watch() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(afterRender, 60); })
      .observe(d, { childList: true, subtree: true });
    afterRender();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  window.SmaelCart = {
    adjust: function (n) { return Math.max(0, n - (protOn() ? 1 : 0)); },
    refresh: function () { return sectionRenderer.renderSection(SECTION, { cache: false, mode: 'hydration' }).then(afterRender); }
  };
})();
